//
// Module for the Repayment Batch - Add Repayment view
//
rs.module("content/participant/benefit/repayments/addrepayment",

    [
        "common/visibility",
        "controls/data/grid",
        "controls/components/event-banner"
    ],

    function (visibility, gridModule, eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, ajaxUrls, repaymentTypes, registersGridLrsApi, priorRepaymentsGridLrsApi) {

            var form = $.js(jsSelectors.form);

            var areRepaymentsCalculated = form.js(jsSelectors.areRepaymentsCalculated);
            var repaymentType = form.js(jsSelectors.repaymentType);
            var numberOfDaysToRepay = form.js(jsSelectors.numberOfDaysToRepay);
            var numberOfDaysToRepayError = form.js(jsSelectors.numberOfDaysToRepayError);
            var calculateButtonContainer = form.js(jsSelectors.calculateButtonContainer, {required: false});
            var calculateButton = form.js(jsSelectors.calculateButton, { required: false });
            var detailsContainer = form.js(jsSelectors.detailsContainer);
            var formActionsContainer = form.js(jsSelectors.formActionsContainer);
            var saveButton = formActionsContainer.js(jsSelectors.saveButton);

            // The calculate button/container are suppressed in the view when there are no available payments to repay
            // so, need to make sure it exists before registering these events
            if (registersGridLrsApi && calculateButtonContainer) {

                // when selected register changes, force user to recalculate
                registersGridLrsApi.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {

                        eventBanner.removeAllMessages();
                        showDetails(false);

                        gridModule.update(
                            ajaxUrls.getPriorRepaymentsGridData,
                            { paymentRegisterKey: registersGridLrsApi.selectedValues[0] },
                            priorRepaymentsGridLrsApi.agGridApi,
                            function done() { }
                        );
                    }

                    _executeSelectionChanged = true;
                });

                repaymentType.change(function () {

                    showDetails(false);

                    if (repaymentType.val() == repaymentTypes.full) {
                        numberOfDaysToRepay.val("").prop("disabled", true).clearErrors();
                        calculateButton.setDisabled(false);
                    }
                    else {
                        numberOfDaysToRepay.prop("disabled", false);
                        calculateButton.setDisabled();
                    }
                });

                numberOfDaysToRepay.change(function () {

                    showDetails(false);

                    if (numberOfDaysToRepayError.text()) {
                        calculateButton.setDisabled();
                    }
                    else {
                        calculateButton.setDisabled(false);
                    }
                });

                calculateButton.click(function () {

                    if (!numberOfDaysToRepayError.text()) {

                        eventBanner.removeAllMessages();

                        $.ajax({
                            url: ajaxUrls.getRepayRegisterDetail,
                            data: {
                                repayRegisterKey: registersGridLrsApi.selectedValues[0],
                                repaymentType: repaymentType.val(),
                                numberOfDaysToRepay: numberOfDaysToRepay.val()
                            },
                            success: function (data) {
                                detailsContainer.html(data);
                                showDetails(true);
                            }
                        });
                    }
                });
            }

            // show/hide details and related fields based on if repayments have been calculated for the selected register
            function showDetails(hasCalculated) {
                areRepaymentsCalculated.val(hasCalculated);

                visibility.setVisible(calculateButtonContainer, !hasCalculated);
                calculateButton.setDisabled(hasCalculated);

                visibility.setVisible(detailsContainer, hasCalculated);

                visibility.setVisible(formActionsContainer, hasCalculated);
                saveButton.setDisabled(!hasCalculated);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);